import { useEffect, useState } from "react";
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import EmptyData from "../../../components/emptyData";
import ModalLoading from "../../../components/modalLoading";
import ProgressBar from "../../../components/progressBar";
import RadioBox from "../../../components/radioBox";
import ManageLayout from "../../../layouts/manage";
import { headers } from "../../../utils/callApi";
import ToastTopHelper from "../../../utils/toast";
import FormPermission from '../components/formPermission';
import TableUser from "../components/tableUser";
import { clearData, exportUser, getUsers } from "../redux/action";
import { getListProjectOfUser } from "../service";
import './index.css';


function ManageUser() {
  
  const initProject = async () => {
    let {success, data} = await getListProjectOfUser(0);
    return data;
  };

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    initProject().then((result) => {
      setProjects(result);
    })
  },[headers]);

  const [selectProjectIndex, setSelectProjectIndex] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [show, setShow] = useState(false);

  const [user, setUser] = useState(null);

  const [showProgressBar, setShowProgressBar] = useState(false);

  function getSheetData(data, header, headerRaw) {
    const sheetData = data.map(function (row) {
      return headerRaw.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    
    return [[...header], ...sheetData];
  }

  const dispatch = useDispatch();
  const [
    page,
    totalPage,
    totalUsers,
    isGettingUsers,
    isGottenUsersFail,
    users,
    isAddingUser,
    isEditingUser,
    isDeletingUser,
    exportPercent,
    exportData,
    isExportedFail,
  ] = useSelector((state) => [
    state.manageUser.page,
    state.manageUser.totalPage,
    state.manageUser.totalUsers,
    state.manageUser.isGettingUsers,
    state.manageUser.isGottenUsersFail,
    state.manageUser.users,
    state.manageUser.isAddingUser,
    state.manageUser.isEditingUser,
    state.manageUser.isDeletingUser,
    state.manageUser.exportPercent,
    state.manageUser.exportData,
    state.manageUser.isExportedFail,
  ]);

  function saveAsExcel() {
    const header = ['Email',
		'Tên nhân viên',
		'SDT nhân viên',
		'Dự án',
		'Bộ phận',
		"Phân quyền",
		"Ngày cập nhật",
		'Người phân quyền'];
    
    const headerRaw = [
      'email',
      'name',
      'phone',
      'project',
      'department',
      'role',
      'update_date',
      'update_by',
    ]
    const sheetData = getSheetData(exportData, header, headerRaw);
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();      
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
    XLSX.writeFile(wb, "ReportUser.xlsx");
  }

  useEffect(() => {
    if(exportPercent !== null && exportPercent !== 0) {
      if(exportPercent !== 100){
        dispatch(exportUser({project: users[0].project, page: (exportPercent * totalPage / 100) + 1}))
      } else {
        setShowProgressBar(true);
        saveAsExcel();
        setTimeout(() => {
          setShowProgressBar(false);
        },[500]);
        ToastTopHelper.success("Xuất report thành công.");
      }
    }
  },[exportPercent])

  useEffect(() => {
    if(isExportedFail) {
      ToastTopHelper.error("Xuất report thất bại.");
    }
  },[isExportedFail])

  useEffect(() => {
    return () => {
      dispatch(clearData())
    }
  },[])

  const breadCrumbs_user= [
      {name: 'Quản lý người dùng'}
  ]
  return (
    <>
      <ManageLayout activeIndex={2} breadcrumbs={breadCrumbs_user}>
        <div className="main_user">
          <div className="el_user_1">
          </div>
          <div className="el_user_2">
            <RadioBox projects={projects.map((pr) => pr.account_name)} selectProjectIndex={selectProjectIndex} handleSelect={(index) => setSelectProjectIndex(index)}></RadioBox>
            <div className="btn_el_user">
              <div className="btn_el_user_2"><Button onClick={() => {
                if(selectProjectIndex !== null) {
                  dispatch(getUsers({project: projects[selectProjectIndex].account_name, page: 1}))
                }
              }}>Tìm kiếm</Button></div>
              <div className="btn_el_user_1"><Button onClick={() => {
                if(selectProjectIndex !== null && totalPage !== 0 && users.length > 0){
                  dispatch(exportUser({project: users[0].project, page: 1}));
                }
              }}>Xuất report</Button></div>
              <div className="btn_el_user_3"><Button onClick={() => {
                setIsEdit(false);
                setShow(true);
              }}>Thêm mới</Button></div>
            </div>
          </div>
          <div className="el_user_3">
          </div>
        </div>
        {exportPercent !== null &&
        <>
          {exportPercent !== 100  && <ProgressBar value_percent={exportPercent.toFixed(2)}></ProgressBar> }
          {exportPercent === 100  && showProgressBar && <ProgressBar value_percent={exportPercent.toFixed(2)}></ProgressBar> }
        </>
        }
        <div className="main_content">
        {isGottenUsersFail ? 
          <EmptyData title="Lấy dữ liệu thất bại."></EmptyData> :
          <>
          {users.length === 0 && page === 0 && totalPage === 0 ? 
            <EmptyData title="Vui lòng chọn dự án và bấm Tìm kiếm để xem nội dung."></EmptyData>
            :
            <>
            {totalUsers === 0 ? 
              <EmptyData title="Không có dữ liệu"></EmptyData>
              :
              <TableUser 
                projects={projects}
                project={projects[selectProjectIndex]}
                editUser={(user) => {
                  setIsEdit(true);
                  setShow(true);
                  setUser(user);
                }}
              ></TableUser>
            }
            </>
          }
          </>
        }
          
        </div>
      </ManageLayout>
      <FormPermission 
        show={show} 
        onHide={() => 
          setShow(false)
        }
        isEdit={isEdit}
        user={user}
        changeProject={(project) => {
          const index = projects.findIndex((p) => p.account_name === project);
          if(index !== -1){
            setSelectProjectIndex(index);
          }
        }}
        projects={projects}
      >
      </FormPermission>

      <ModalLoading 
        show={isAddingUser || isEditingUser || isDeletingUser}
        content={'Đang xử lý...'}
      ></ModalLoading>

      <ModalLoading 
        show={isGettingUsers}
        content={'Đang lấy dữ liệu...'}
      ></ModalLoading>
    </>
  )
}

export default ManageUser;